import { render, staticRenderFns } from "./OrientationFilterWidget.vue?vue&type=template&id=f94fcc76&"
import script from "./OrientationFilterWidget.vue?vue&type=script&lang=js&"
export * from "./OrientationFilterWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports